import * as React from 'react'

function SvgCheckIcon(props) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 60 60"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M38.8244 44C30.9866 38.8391 26.8384 35.9628 20 30.7975L20.0041 29.1959C27.2196 23.8018 31.3787 20.9636 38.8191 16L40 17.6692C32.953 22.3704 28.8781 25.1459 22.3469 30.0023C28.5244 34.642 32.6019 37.4559 39.9948 42.3238L38.8244 44Z" />
    </svg>
  )
}

export default SvgCheckIcon
